"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cdn = void 0;
exports.cdn = {
    base: 'https://assets.cdn.feather-insurance.com',
};
